(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };

    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 1.32,
        scrollbar: {
          el: this.selectors.scrollbar,
          draggable: true,
        },
        spaceBetween: 16,
        nested: true,
        breakpoints: {
          750: {
            slidesPerView: 2.3,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 4,
          },
        },
      };
      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
